import axios from "axios";
import { create } from "zustand";
// import {produce} from 'immer';

export const useGlobalStore = create((set, get) => ({
  sidebar: false,
  gender: [],
  maritalStatus: [],
  countries: [],
  paymentType: [],

  toggleSidebar: () => set((state) => ({ sidebar: !state.sidebar })),
  closeSidebar: () => set({ sidebar: false }),

  // Function to get genders list from controllers > customer.control
  fetchGender: async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/user/get-gender`
      );

      if (res?.data) {
        set({ gender: res.data });
      }
    } catch (error) {
      console.error(
        "Error fetching gender data:",
        error?.response?.data || error.message
      );
    }
  },

  // Function to get Marital Status list from controllers > customer.control
  fetchMaritalStatus: async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/user/get-marital-status`
      );
      if (res?.data) {
        set({ maritalStatus: res.data });
      }
    } catch (error) {
      console.error(
        "Error fetching marital data:",
        error?.response?.data || error.message
      );
    }
  },

  // Function to get countries list, from controllers > general.control
  fetchDataCountries: async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/general/get-countries`
      );
      if (res?.data) {
        set({ countries: res.data });
      }
    } catch (error) {
      console.error(
        "Error fetching countries:",
        error?.response?.data || error.message
      );
    }
  },

  // Function to get payment type list, from controllers > payment.type.control
  fetchDataPaymentType: async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/finances/get-payment-type`
      );
      if (res?.data) {
        set({ paymentType: res.data });
      }
    } catch (error) {
      console.error(
        "Error fetching Payment Type:",
        error?.response?.data || error.message
      );
    }
  },
}));
